// src/features/inventory/hooks/useItemSuppliers.js
import { useState, useCallback } from 'react';
import { suppliersAPI } from '../services/suppliers';
import { useApi } from '../../../hooks/api/useApi';

export function useItemSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchSuppliersForItem = useCallback(async (itemId) => {
    const result = await execute(() => suppliersAPI.getForItem(itemId));
    if (result.success) {
      setSuppliers(result.data.data || []);
    }
    return result;
  }, [execute]);

  return { suppliers, loading, error, clearError, fetchSuppliersForItem };
}
